export let BusinessBoxId;

(function (BusinessBoxId) {
  BusinessBoxId["OnlinePresence"] = "build-online-presence";
  BusinessBoxId["FindCustomers"] = "find-customers-online";
  BusinessBoxId["B2B"] = "b2b-sales-process";
  BusinessBoxId["DigitalEvent"] = "run-digital-event";
})(BusinessBoxId || (BusinessBoxId = {}));

export function isBusinessBoxId(businessBoxId) {
  return businessBoxId !== undefined && Object.values(BusinessBoxId).some(id => id === businessBoxId);
}